export default __webpack_public_path__ + "static/3-beaee098f56b166752378623ac3e8944.jpeg";